import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import MuiThemeProviderLegacy from 'material-ui-legacy/styles/MuiThemeProvider'
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles'
import injectTapEventPlugin from 'react-tap-event-plugin'
import App from './components/App.jsx'
import './styles/index.css' // We have SCSS, but in watch mode. Include the .css file.

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin()

// Init new theme
const theme = createMuiTheme()
/* TODO: Customization - https://material.io/color/#!/?view.left=0&view.right=0&primary.color=01579B&secondary.color=CFD8DC&primary.text.color=ffffff&secondary.text.color=000000
const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#4f83cc',
      main: '#01579b',
      dark: '#002f6c',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ffffff',
      main: '#cfd8dc',
      dark: '#9ea7aa',
      contrastText: '#000',
    },
  },
})
*/

ReactDOM.render(
  <BrowserRouter>
    <MuiThemeProviderLegacy>
      <MuiThemeProvider theme={theme}>
        <App />
      </MuiThemeProvider>
    </MuiThemeProviderLegacy>
  </BrowserRouter>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js